export const general = {
  upload: {
    file_name: "Nome do arquivo",
    file_size: "Tamanho do arquivo",
    file_invalid_type: "O tipo de arquivo deve ser {{messageSuffix}}",
    file_too_large: "O arquivo é maior que {{maxSize}}{{unit}}",
    file_too_small: "O arquivo é menor que {{minSize}}{{unit}}",
    too_many_files: "Muitos arquivos, apenas {{maxFiles}} permitidos",
    rejected_header: "Arquivos rejeitados",
    release_drop: "Arraste e solte o arquivo aqui",
    select_from_your_computer: "ou selecione do seu computador",
  },
  table: {
    reset_table_layout: "Redefinir layout da tabela",
  },
  access_denied: "Você não tem acesso a esta página",
  assign_selected: "Atribuir selecionados",
  Link: "Link",
  similarity: {
    High: "Alta",
    Low: "Baixa",
    Medium: "Média",
    Very_high: "Muito alta",
    Very_low: "Muito baixa",
    score: "Pontuação de similaridade",
  },
  show: "Mostrar",
  hide: "Ocultar",
  this_action_cannot_be_undone: "Esta ação não pode ser desfeita",
  continue: "Continuar",
  current: "Atual",
  latest: "Mais recente",
  download_excel: "Baixar Excel",
  changes: "Alterações",
  compare: "Comparar",
  tenant_not_provided_for_current_user:
    "Locatário para o usuário atual não fornecido. Verifique a configuração da visualização (função do endpoint).",
  overview: "Visão geral",
  only_paying_customers_can_access_this_feature: "Apenas clientes pagantes podem acessar este recurso",
  add_file_url: "Adicionar URL do arquivo",
  add_file_URL_button: "Botão de adicionar URL do arquivo",
  Alert: "Alerta",
  All: "Todos",
  other: "Outro",
  All_changes_have_been_saved: "Todas as alterações foram salvas.",
  All_sub_themes: "Todos os subtemas",
  All_themes: "Todos os temas",
  Apply: "Aplicar",
  Approve: "Aprovar",
  are_you_sure: "Tem certeza?",
  Assessment: "Avaliação",
  Assessments: "Avaliações",
  Back: "Voltar",
  Cancel: "Cancelar",
  close: "Fechar",
  Clear_all: "Limpar tudo",
  Collapse_all: "Recolher tudo",
  Companies: "Empresas",
  Confirm: "Confirmar",
  Dashboard: "Painel",
  Declined: "Recusado",
  Delete: "Excluir",
  Description: "Descrição",
  Deselect_all: "Desmarcar tudo",
  Documentation: "Documentação",
  Duplicate: "Duplicar",
  Edit: "Editar",
  Email: "E-mail",
  Error: "Erro",
  Expand_all: "Expandir tudo",
  File: "Arquivo",
  First_name: "Primeiro nome",
  Help: "Ajuda",
  hide_menu: "Ocultar menu",
  Important_Notice: "Aviso Importante",
  Incorrect_data: "Dados incorretos",
  Job_title: "Cargo",
  Last_update: "Última atualização",
  load_more: "carregar mais",
  Next: "Próximo",
  No: "Não",
  no_answer: "Sem resposta",
  No_results: "Sem resultados",
  Notifications: "Notificações",
  Ok: "Ok",
  Open_settings: "Abrir configurações",
  or: "ou",
  Proceed: "Prosseguir",
  Protocol: "Protocolo",
  Remove: "Remover",
  Reports: "Relatórios",
  Reset_to_default: "Redefinir para padrão",
  Reviewers: "Revisores",
  Role: "Função",
  roles: {
    Data_provider: "Fornecedor de dados",
    data_providers: "Fornecedores de dados",
    reviewer: "revisor",
    Reviewer: "Revisor",
    Verifier: "Verificador",
  },
  Roles: "Funções",
  Row: "Linha",
  Save: "Salvar",
  Saving: "Salvando...",
  search: "pesquisar",
  Search: "Pesquisar",
  Search_bar: "Barra de pesquisa",
  Select: "Selecionar",
  Select_all: "Selecionar tudo",
  show_menu: "Mostrar menu",
  Show_more: "Mostrar mais",
  show_less: "Mostrar menos",
  Site: "Site",
  Site_creation: "Criação de site",
  Site_edition: "Edição de site",
  Sites: "Sites",
  Standard: "Padrão",
  standards: "padrões",
  SupportPortal: "Portal de Suporte",
  Surname: "Sobrenome",
  there_are_no_files: "Não há arquivos.",
  This_field_is_required: "Este campo é obrigatório",
  "Type_name_surname_or_e-mail": "Digite nome, sobrenome ou e-mail",
  Type_search_text_here: "Digite o texto de pesquisa aqui",
  Type_to_search: "Digite para pesquisar",
  Unsaved_Changes: "Alterações não salvas",
  Upload: "Enviar",
  Url: "Url",
  Users: "Usuários",
  validation: {
    At_last_one_site_is_required: "Pelo menos um site é obrigatório",
    At_last_one_standard_is_required: "Pelo menos um padrão é obrigatório",
    Coordinator_is_required: "Coordenador é obrigatório",
    Country_is_required: "País é obrigatório",
    Email_is_used_in_another_company: "E-mail está sendo usado em outra empresa",
    Incorrect_email: "E-mail incorreto",
    name_is_required: "Nome é obrigatório.",
    Scope_of_applicability_is_required: "Escopo de aplicabilidade é obrigatório",
    site_is_required: "Site é obrigatório.",
    this_field_is_required: "Este campo é obrigatório.",
    This_field_must_be_unique: "Este campo deve ser único.",
  },
  Yes: "Sim",
  You_have_unsaved_changes_Are_you_sure_you_want_to_leave:
    "Você tem alterações não salvas. Tem certeza de que deseja sair?",
  ai_disclaimer: {
    title: "Aviso de Tradução por IA",
    message:
      "Esta tradução das perguntas do protocolo e requisitos padrão foi gerada usando ferramentas de inteligência artificial e pode conter imprecisões.",
    accept: "Eu Entendo",
    go_back: "Voltar",
    switch_to_english: "Mudar para Inglês",
  },
} as const;
